import { createContext } from "../fable_modules/Feliz.2.9.0/./Internal.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { SearchParams_fromMap_Z305ADAA2 } from "../ClientTypes.fs.js";
import { Feliz_Router_Router__Router_getQuery_Static_Z721C83C5 } from "../Prelude.fs.js";
import { empty as empty_1, tryPick } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { comparePrimitives, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { empty } from "../fable_modules/fable-library-js.4.24.0/Map.js";

export const Context_RouterContext = createContext("Router", ["", ""]);

export function useFeliz_React__React_useTypedParams_Static() {
    const query = reactApi.useContext(Context_RouterContext)[1];
    const dependencies_1 = [query];
    return reactApi.useMemo(() => SearchParams_fromMap_Z305ADAA2(Feliz_Router_Router__Router_getQuery_Static_Z721C83C5(query)), dependencies_1);
}

export function useFeliz_React__React_useSearchType_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 0) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

export function useFeliz_React__React_useInfoPanel_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 4) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

export function useFeliz_React__React_useLabels_Static_Z485ADA6F(specificDomainEntity) {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams, specificDomainEntity];
    return reactApi.useMemo(() => defaultArg(tryPick((tp) => {
        let matchResult, domainEntity_1, labels_1;
        if (tp.tag === 5) {
            if (equals(tp.fields[0], specificDomainEntity)) {
                matchResult = 0;
                domainEntity_1 = tp.fields[0];
                labels_1 = tp.fields[1];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return labels_1;
            default:
                return undefined;
        }
    }, tParams), empty({
        Compare: comparePrimitives,
    })), dependencies_1);
}

export function useFeliz_React__React_useCondition_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 7) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

export function useFeliz_React__React_useStatus_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 6) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

export function useFeliz_React__React_useCriticality_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 8) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

export function useFeliz_React__React_useMaturity_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 9) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

export function useFeliz_React__React_useProgressStatus_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 10) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

export function useFeliz_React__React_useUnplanned_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 11) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

export function useFeliz_React__React_useAttributes_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => defaultArg(tryPick((tp) => {
        if (tp.tag === 13) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), empty_1()), dependencies_1);
}

export function useFeliz_React__React_useDateRange_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 12) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

export function useFeliz_React__React_useDashboardCategory_Static() {
    const tParams = useFeliz_React__React_useTypedParams_Static();
    const dependencies_1 = [tParams];
    return reactApi.useMemo(() => tryPick((tp) => {
        if (tp.tag === 14) {
            return tp.fields[0];
        }
        else {
            return undefined;
        }
    }, tParams), dependencies_1);
}

